import { useState } from 'react';
import { Typography } from '@mui/material';
import { getUserInitials } from 'utils/getUserInitials';
import { Customer } from 'models';
import QRModal from 'views/modals/QRModal';
import CopyToClipboard from 'components/CopyToClipboard';
import { pushAnalyticsEvent } from 'helpers/analytics';
import QRButton from 'components/QRButton';

import {
  InitialsCircle,
  Label,
  ProfileIcon,
  QRBox,
  StyledBox,
  UserInitials,
  Wrapper,
} from './UserProfileCard.styles';

export interface UserProfileCardProps {
  className?: string;
  userData: Customer;
}

const UserProfileCard = ({ className, userData }: UserProfileCardProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const {
    personalDetails: { firstName, lastName, memberId },
  } = userData;

  const handleOnModalToggle = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleOnCopy = () => {
    pushAnalyticsEvent({ event: 'userCopyID', location: 'Profile Page' });
  };

  const userInitials = getUserInitials(firstName, lastName);
  const fullName = `${firstName} ${lastName}`;
  const title = `Zillionaire ID: ${memberId}`;
  const description = `Show your Zillionaire ID to your server to register your visit and bank those Zs.`;

  return (
    <>
      <Wrapper className={className}>
        <ProfileIcon>
          <InitialsCircle />
          <UserInitials variant="h1">{userInitials}</UserInitials>
        </ProfileIcon>
        <StyledBox>
          <QRBox>
            <QRButton onClick={handleOnModalToggle} />
          </QRBox>
          <Typography variant="h2" gutterBottom>
            {fullName}
          </Typography>

          <Label variant="h6">Zillionaire ID</Label>
          <Typography variant="h4" gutterBottom>
            {memberId}
            <CopyToClipboard value={memberId} onCopy={handleOnCopy} />
          </Typography>
        </StyledBox>
      </Wrapper>

      <QRModal
        title={title}
        isOpen={isModalOpen}
        description={description}
        onClose={handleOnModalToggle}
        code={memberId}
      />
    </>
  );
};

export default UserProfileCard;
